import BaseUseCase from "../../../base_use_case.js";

class ShowUserStatisticsUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/statistics/users/${identifier}`,
    });
  }
}

const instance = new ShowUserStatisticsUseCase();
export default instance;